const SRS_KEY = "quran-vocab-srs-store";
const LESSON_KEY = "quran-vocab-last-lesson";

const coreSample = [
  { id: "w-0001", a: "اللّه", t: "Allah", m_id: "Allah", cat: "theology", rank: 1, ex: { s: 1, v: 1 } },
  { id: "w-0002", a: "قال", t: "qaala", m_id: "berkata", cat: "verb", rank: 2, ex: { s: 2, v: 30 } },
  { id: "w-0003", a: "إنّ", t: "inna", m_id: "sesungguhnya", cat: "particle", rank: 3, ex: { s: 2, v: 9 } },
  { id: "w-0004", a: "هذا", t: "haadha", m_id: "ini", cat: "pronoun", rank: 4, ex: { s: 2, v: 2 } },
  { id: "w-0005", a: "ذلك", t: "dzaalika", m_id: "itu", cat: "pronoun", rank: 5 },
  { id: "w-0006", a: "كتاب", t: "kitaab", m_id: "kitab", cat: "noun", rank: 6 },
  { id: "w-0007", a: "آمن", t: "aamana", m_id: "beriman", cat: "verb", rank: 7 },
  { id: "w-0008", a: "رحيم", t: "rahiim", m_id: "penyayang", cat: "adjective", rank: 8 },
  { id: "w-0009", a: "نحن", t: "nahnu", m_id: "kami", cat: "pronoun", rank: 9 },
  { id: "w-0010", a: "هم", t: "hum", m_id: "mereka", cat: "pronoun", rank: 10 },
  { id: "w-0011", a: "هو", t: "huwa", m_id: "dia (lk)", cat: "pronoun", rank: 11 },
  { id: "w-0012", a: "هي", t: "hiya", m_id: "dia (pr)", cat: "pronoun", rank: 12 },
  { id: "w-0013", a: "ما", t: "maa", m_id: "apa", cat: "particle", rank: 13 },
  { id: "w-0014", a: "من", t: "min", m_id: "dari", cat: "particle", rank: 14 },
  { id: "w-0015", a: "على", t: "alaa", m_id: "atas", cat: "particle", rank: 15 },
  { id: "w-0016", a: "إلى", t: "ila", m_id: "ke", cat: "particle", rank: 16, ex: { s: 1, v: 5 } },
  { id: "w-0017", a: "ربّ", t: "rabb", m_id: "Tuhan", cat: "theology", rank: 17 },
  { id: "w-0018", a: "آية", t: "aayah", m_id: "ayat", cat: "noun", rank: 18 },
  { id: "w-0019", a: "جنة", t: "jannah", m_id: "surga", cat: "noun", rank: 19 },
  { id: "w-0020", a: "نار", t: "naar", m_id: "neraka", cat: "noun", rank: 20 },
  { id: "w-0021", a: "حقّ", t: "haqq", m_id: "kebenaran", cat: "noun", rank: 21 },
  { id: "w-0022", a: "باطل", t: "baatil", m_id: "kebatilan", cat: "noun", rank: 22 },
  { id: "w-0023", a: "رحمن", t: "rahmaan", m_id: "Maha Pengasih", cat: "theology", rank: 23 },
  { id: "w-0024", a: "علم", t: "ilm", m_id: "ilmu", cat: "noun", rank: 24 },
  { id: "w-0025", a: "عمل", t: "amal", m_id: "amal", cat: "noun", rank: 25 },
  { id: "w-0026", a: "خلق", t: "khalaqa", m_id: "menciptakan", cat: "verb", rank: 26 },
  { id: "w-0027", a: "جعل", t: "ja'ala", m_id: "menjadikan", cat: "verb", rank: 27 },
  { id: "w-0028", a: "رسل", t: "rusul", m_id: "para rasul", cat: "noun", rank: 28 },
  { id: "w-0029", a: "كتابٌ", t: "kitaabun", m_id: "sebuah kitab", cat: "noun", rank: 29 },
  { id: "w-0030", a: "آمنوا", t: "aamanuu", m_id: "mereka beriman", cat: "verb", rank: 30 },
  { id: "w-0031", a: "في", t: "fii", m_id: "di", cat: "particle", rank: 31 },
  { id: "w-0032", a: "كان", t: "kaana", m_id: "adalah", cat: "verb", rank: 32 },
  { id: "w-0033", a: "لا", t: "laa", m_id: "tidak", cat: "particle", rank: 33 },
  { id: "w-0034", a: "كلّ", t: "kull", m_id: "segala", cat: "noun", rank: 34 },
  { id: "w-0035", a: "شيء", t: "syai'", m_id: "sesuatu", cat: "noun", rank: 35 },
  { id: "w-0036", a: "يوم", t: "yaum", m_id: "hari", cat: "noun", rank: 36 },
  { id: "w-0037", a: "سبيل", t: "sabiil", m_id: "jalan", cat: "noun", rank: 37 },
  { id: "w-0038", a: "قوم", t: "qawm", m_id: "kaum", cat: "noun", rank: 38 },
  { id: "w-0039", a: "الناس", t: "an-naas", m_id: "manusia", cat: "noun", rank: 39 },
  { id: "w-0040", a: "ربّنا", t: "rabbanaa", m_id: "Tuhan kami", cat: "theology", rank: 40 },
  { id: "w-0041", a: "آمنا", t: "aamannaa", m_id: "kami beriman", cat: "verb", rank: 41 },
  { id: "w-0042", a: "يعملون", t: "ya'maluun", m_id: "mereka beramal", cat: "verb", rank: 42 },
  { id: "w-0043", a: "يعلمون", t: "ya'lamuun", m_id: "mereka mengetahui", cat: "verb", rank: 43 },
  { id: "w-0044", a: "آيات", t: "aayaat", m_id: "ayat-ayat", cat: "noun", rank: 44 },
  { id: "w-0045", a: "رسول", t: "rasuul", m_id: "rasul", cat: "noun", rank: 45 },
  { id: "w-0046", a: "نبيّ", t: "nabiyy", m_id: "nabi", cat: "noun", rank: 46 },
  { id: "w-0047", a: "رحمة", t: "rahmah", m_id: "rahmat", cat: "noun", rank: 47 },
  { id: "w-0048", a: "مغفرة", t: "maghfirah", m_id: "ampunan", cat: "noun", rank: 48 },
  { id: "w-0049", a: "رزق", t: "rizq", m_id: "rizki", cat: "noun", rank: 49 },
  { id: "w-0050", a: "صراط", t: "siraat", m_id: "jalan", cat: "noun", rank: 50 },
  { id: "w-0051", a: "مستقيم", t: "mustaqiim", m_id: "lurus", cat: "adjective", rank: 51 },
  { id: "w-0052", a: "عباد", t: "ibaad", m_id: "hamba-hamba", cat: "noun", rank: 52 },
  { id: "w-0053", a: "عبد", t: "abd", m_id: "hamba", cat: "noun", rank: 53 },
  { id: "w-0054", a: "الأرض", t: "al-ardh", m_id: "bumi", cat: "noun", rank: 54 },
  { id: "w-0055", a: "السماء", t: "as-samaa'", m_id: "langit", cat: "noun", rank: 55 },
  { id: "w-0056", a: "ماء", t: "maa'", m_id: "air", cat: "noun", rank: 56 },
  { id: "w-0057", a: "قلب", t: "qalb", m_id: "hati", cat: "noun", rank: 57 },
  { id: "w-0058", a: "نفس", t: "nafs", m_id: "jiwa", cat: "noun", rank: 58 },
  { id: "w-0059", a: "الدنيا", t: "dunya", m_id: "dunia", cat: "noun", rank: 59 },
  { id: "w-0060", a: "الآخرة", t: "al-aakhirah", m_id: "akhirat", cat: "noun", rank: 60 }
];

const DATASET_KEY = "vocab-core-dataset";
export const getCoreDataset = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = JSON.parse(localStorage.getItem(DATASET_KEY) || "null");
    if (!Array.isArray(raw)) return null;
    return raw.filter((w) => w && w.a && w.m_id && w.id);
  } catch {
    return null;
  }
};
export const setCoreDataset = (arr) => {
  if (typeof window === "undefined") return false;
  try {
    if (!Array.isArray(arr)) return false;
    localStorage.setItem(DATASET_KEY, JSON.stringify(arr));
    return true;
  } catch {
    return false;
  }
};

export const loadCoreVocab = () => {
  const ds = getCoreDataset();
  return Array.isArray(ds) && ds.length ? ds : coreSample;
};

const nowTs = () => Date.now();

export const getSrsStore = () => {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(localStorage.getItem(SRS_KEY) || "{}");
  } catch {
    return {};
  }
};

export const saveSrsStore = (store) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(SRS_KEY, JSON.stringify(store));
};

const nextInterval = (reps, ef) => {
  if (reps <= 1) return 1 * 24 * 60 * 60 * 1000;
  if (reps === 2) return 3 * 24 * 60 * 60 * 1000;
  return Math.round((reps - 1) * ef) * 24 * 60 * 60 * 1000;
};

const updateEf = (ef, q) => {
  const next = ef + (0.1 - (5 - q) * (0.08 + (5 - q) * 0.02));
  return Math.max(1.3, Math.min(next, 2.5));
};

export const updateSrsItem = (id, score) => {
  const store = getSrsStore();
  const curr = store[id] || { ef: 2.0, reps: 0, interval: 0, dueAt: nowTs(), lastScore: null };
  const reps = score < 3 ? 0 : curr.reps + 1;
  let ef = updateEf(curr.ef, score);
  if (isHard(id)) {
    ef = Math.max(1.3, ef - 0.2);
  }
  let interval = score < 3 ? 0 : nextInterval(reps, ef);
  if (isHard(id) && interval > 0) {
    interval = Math.max(12 * 60 * 60 * 1000, Math.floor(interval / 2));
  }
  const dueAt = score < 3 ? nowTs() + 12 * 60 * 60 * 1000 : nowTs() + interval;
  store[id] = { ef, reps, interval, dueAt, lastScore: score };
  saveSrsStore(store);
  return store[id];
};

export const planDailyLesson = (count = 8, category) => {
  const cap = getRankCap();
  const all = loadCoreVocab()
    .filter((w) => (!category || w.cat === category) && (w.rank || 999) <= cap)
    .sort((a, b) => a.rank - b.rank);
  const store = getSrsStore();
  const due = all.filter((w) => (store[w.id]?.dueAt || 0) <= nowTs());
  const newItems = all.filter((w) => !store[w.id]).slice(0, count);
  const mix = [...due.slice(0, Math.ceil(count / 2)), ...newItems].slice(0, count);
  if (typeof window !== "undefined") {
    localStorage.setItem(LESSON_KEY, JSON.stringify({ at: nowTs(), ids: mix.map((m) => m.id), category: category || null }));
  }
  return mix;
};

export const computeStats = () => {
  const all = loadCoreVocab();
  const store = getSrsStore();
  let mastered = 0;
  const catStats = {};
  for (const w of all) {
    const s = store[w.id];
    if (s?.reps >= 2 && (s?.lastScore || 0) >= 4) mastered++;
    catStats[w.cat] = catStats[w.cat] || { total: 0, correct: 0 };
    catStats[w.cat].total++;
    catStats[w.cat].correct += (s?.lastScore || 0) >= 4 ? 1 : 0;
  }
  const weakCats = Object.entries(catStats)
    .map(([cat, v]) => ({ cat, rate: v.total ? v.correct / v.total : 0 }))
    .sort((a, b) => a.rate - b.rate)
    .slice(0, 2)
    .map((x) => x.cat);
  return { mastered, total: all.length, catStats, weakCats };
};

export const getDueCount = () => {
  const all = loadCoreVocab();
  const store = getSrsStore();
  return all.filter((w) => (store[w.id]?.dueAt || 0) <= nowTs()).length;
};

export const planDueLesson = (count = 8, category) => {
  const cap = getRankCap();
  const all = loadCoreVocab().filter((w) => (!category || w.cat === category) && (w.rank || 999) <= cap);
  const store = getSrsStore();
  const due = all
    .filter((w) => (store[w.id]?.dueAt || 0) <= nowTs())
    .sort((a, b) => (store[a.id]?.dueAt || 0) - (store[b.id]?.dueAt || 0))
    .slice(0, count);
  if (typeof window !== "undefined") {
    localStorage.setItem(LESSON_KEY, JSON.stringify({ at: nowTs(), ids: due.map((m) => m.id), mode: "due", category: category || null }));
  }
  return due;
};

const TARGET_KEY = "vocab-daily-target";
const RANK_CAP_KEY = "vocab-rank-cap";
export const getDailyTarget = () => {
  if (typeof window === "undefined") return 8;
  const raw = Number(localStorage.getItem(TARGET_KEY) || "8");
  return [6, 8, 10].includes(raw) ? raw : 8;
};
export const setDailyTarget = (n) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(TARGET_KEY, String(n));
};
export const getRankCap = () => {
  if (typeof window === "undefined") return 999;
  const raw = Number(localStorage.getItem(RANK_CAP_KEY) || "60");
  return [30, 60, 100, 999].includes(raw) ? raw : 60;
};
export const setRankCap = (n) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(RANK_CAP_KEY, String(n));
};

const STATS_KEY = "vocab-daily-stats";
const dayStr = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};
const prevDayStr = (s) => {
  const d = new Date(s + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() - 1);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};
const getStats = () => {
  if (typeof window === "undefined") return { byDay: {}, days: [] };
  try {
    return JSON.parse(localStorage.getItem(STATS_KEY) || '{"byDay":{},"days":[]}');
  } catch {
    return { byDay: {}, days: [] };
  }
};
const saveStats = (s) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(STATS_KEY, JSON.stringify(s));
};
export const recordDaily = (isCorrect) => {
  const s = getStats();
  const k = dayStr();
  const item = s.byDay[k] || { total: 0, correct: 0, seconds: 0 };
  item.total++;
  if (isCorrect) {
    item.correct++;
    if (!s.days.includes(k)) s.days.push(k);
  }
  s.byDay[k] = item;
  saveStats(s);
};
export const getRetention7d = () => {
  const s = getStats();
  const today = dayStr();
  const days = [];
  let cur = today;
  for (let i = 0; i < 7; i++) {
    days.push(cur);
    cur = prevDayStr(cur);
  }
  return days.map((d) => {
    const item = s.byDay[d] || { total: 0, correct: 0, seconds: 0 };
    const rate = item.total ? item.correct / item.total : 0;
    return { day: d, rate };
  });
};
export const recordSession = (durationSec) => {
  const s = getStats();
  const k = dayStr();
  const item = s.byDay[k] || { total: 0, correct: 0, seconds: 0 };
  item.seconds += Math.max(0, Number(durationSec) || 0);
  s.byDay[k] = item;
  if (!s.days.includes(k)) s.days.push(k);
  saveStats(s);
};
export const getWeeklyMinutes = () => {
  const s = getStats();
  const today = dayStr();
  const days = [];
  let cur = today;
  for (let i = 0; i < 7; i++) {
    days.push(cur);
    cur = prevDayStr(cur);
  }
  const sumSec = days.reduce((acc, d) => acc + ((s.byDay[d]?.seconds || 0)), 0);
  return Math.round(sumSec / 60);
};

export const getWeeklyMinutesBars = () => {
  const s = getStats();
  const today = dayStr();
  const days = [];
  let cur = today;
  for (let i = 0; i < 7; i++) {
    days.push(cur);
    cur = prevDayStr(cur);
  }
  return days.map((d) => ({ day: d, minutes: Math.round((s.byDay[d]?.seconds || 0) / 60) }));
};

export const getRawStats = () => {
  return getStats();
};
export const getStreak = () => {
  const s = getStats();
  const set = new Set(s.days);
  let count = 0;
  let cur = dayStr();
  while (set.has(cur)) {
    count++;
    cur = prevDayStr(cur);
  }
  return count;
};
export const resetVocabProgress = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(SRS_KEY);
  localStorage.removeItem(STATS_KEY);
  localStorage.removeItem(LESSON_KEY);
};

const HARD_KEY = "vocab-hard-set";
export const getHardSet = () => {
  if (typeof window === "undefined") return new Set();
  try {
    const arr = JSON.parse(localStorage.getItem(HARD_KEY) || "[]");
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
};
export const isHard = (id) => getHardSet().has(id);
export const toggleHard = (id) => {
  if (typeof window === "undefined") return;
  const set = getHardSet();
  if (set.has(id)) set.delete(id); else set.add(id);
  localStorage.setItem(HARD_KEY, JSON.stringify([...set]));
};
export const getHardCount = () => getHardSet().size;

export const planHardLesson = (count = 8, category) => {
  const set = getHardSet();
  const ids = new Set(set);
  const cap = getRankCap();
  const all = loadCoreVocab().filter((w) => (!category || w.cat === category) && (w.rank || 999) <= cap && ids.has(w.id));
  const store = getSrsStore();
  const dueFirst = all
    .sort((a, b) => (store[a.id]?.dueAt || 0) - (store[b.id]?.dueAt || 0))
    .slice(0, count);
  if (typeof window !== "undefined") {
    localStorage.setItem(LESSON_KEY, JSON.stringify({ at: nowTs(), ids: dueFirst.map((m) => m.id), mode: "hard", category: category || null }));
  }
  return dueFirst;
};

const ACH_KEY = "vocab-achievements";
const getAch = () => {
  if (typeof window === "undefined") return [];
  try {
    const arr = JSON.parse(localStorage.getItem(ACH_KEY) || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};
const saveAch = (arr) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(ACH_KEY, JSON.stringify(arr));
};
export const getAchievements = () => getAch();
export const grantAchievement = (id, title, desc) => {
  const arr = getAch();
  if (arr.find((a) => a.id === id)) return false;
  arr.push({ id, title, desc, at: nowTs() });
  saveAch(arr);
  return true;
};
export const evaluateAchievements = (summary) => {
  const stats = computeStats();
  const streak = getStreak();
  const hardCount = getHardSet().size;
  const newly = [];
  if (grantAchievement("first_session", "Sesi Pertama", "Menyelesaikan sesi kosakata")) newly.push("first_session");
  if (summary?.correct >= summary?.total && summary?.total >= 6) {
    if (grantAchievement("perfect_session", "Sesi Sempurna", "Menjawab semua benar")) newly.push("perfect_session");
  }
  if (streak >= 3) {
    if (grantAchievement("streak_3", "Streak 3 Hari", "Berlatih 3 hari berturut-turut")) newly.push("streak_3");
  }
  if (streak >= 7) {
    if (grantAchievement("streak_7", "Streak 7 Hari", "Berlatih 7 hari berturut-turut")) newly.push("streak_7");
  }
  if (streak >= 14) {
    if (grantAchievement("streak_14", "Streak 14 Hari", "Berlatih 14 hari berturut-turut")) newly.push("streak_14");
  }
  if (stats.mastered >= 20) {
    if (grantAchievement("master_20", "Kuasai 20 Kata", "Menguasai 20 kata inti")) newly.push("master_20");
  }
  if (stats.mastered >= 50) {
    if (grantAchievement("master_50", "Kuasai 50 Kata", "Menguasai 50 kata inti")) newly.push("master_50");
  }
  if (stats.mastered >= 100) {
    if (grantAchievement("master_100", "Kuasai 100 Kata", "Menguasai 100 kata inti")) newly.push("master_100");
  }
  if (hardCount >= 5) {
    if (grantAchievement("hard_worker", "Rajin Latih Sulit", "Menandai 5+ kata sulit")) newly.push("hard_worker");
  }
  if (getWeeklyMinutes() >= 60) {
    if (grantAchievement("weekly_60m", "Konsisten 60 mnt/minggu", "Belajar total 60 menit dalam 7 hari")) newly.push("weekly_60m");
  }
  return newly;
};

export const importVocabProgress = (data) => {
  if (typeof window === "undefined") return false;
  try {
    if (data?.srs && typeof data.srs === "object") {
      localStorage.setItem(SRS_KEY, JSON.stringify(data.srs));
    }
    if (Array.isArray(data?.hard)) {
      localStorage.setItem(HARD_KEY, JSON.stringify(data.hard));
    }
    if (data?.stats && typeof data.stats === "object") {
      localStorage.setItem(STATS_KEY, JSON.stringify(data.stats));
    }
    if (Array.isArray(data?.dataset)) {
      setCoreDataset(data.dataset);
    }
    return true;
  } catch {
    return false;
  }
};
